import React from 'react';
import useReveal from '../../hooks/useReveal';
import { portfolioData } from '../../data/portfolioData';

export default function Skills() {
  const { skills } = portfolioData;
  const [ref, shown] = useReveal();

  return (
    <section className="section" id="stack" ref={ref}>
      <div className={`reveal ${shown ? 'in' : ''}`}>
        <span className="eyebrow">03 — The toolbox</span>
        <h2 className="section-title">
          <span className="outline-text">Tech</span> stack
        </h2>
      </div>

      <div className="skills-grid">
        {skills.map((group, i) => (
          <div
            className={`skill-cell reveal ${shown ? 'in' : ''}`}
            key={group.category}
            style={{ transitionDelay: `${(i % 3) * 0.08}s` }}
          >
            <div className="skill-cat">
              <span className="idx">{String(i + 1).padStart(2, '0')}</span>
              {group.category}
            </div>
            <div className="skill-items">
              {group.items.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
